"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import type { PostDetails } from "@/types/posts";
import { PostCard } from "@/ui/post-cards/card";
export function CardGrid(t0) {
  const $ = _c(4);
  const {
    posts
  } = t0;
  let t1;
  if ($[0] !== posts) {
    t1 = posts.map(_temp);
    $[0] = posts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="container max-w-screen px-6 grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:gap-x-6">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(post, index) {
  return <motion.div key={post.id} initial={{
    opacity: 0,
    y: 50
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className={`${index % 2 === 0 ? "md:mt-8 mt-4" : ""}`}><PostCard post={post} /></motion.div>;
}